<template>
    <v-layout row wrap>
        <v-flex class="layout xs12" style="padding-top:20px">

<!--            SAF-->
            <div v-if="isSafObservation(currentObservacion.author)" style="margin-right:15px" class="grey--text xs4 flex"
                 :class="{ 'text-xs-right':  isSafObservation(currentObservacion.author) }">
                <v-tooltip bottom class="action-buttons" v-if="allowed === 'admin' && currentObservacion.canEdit">
                    <v-btn small icon flat color="#293968" slot="activator" v-if="editable">
                        <v-icon color="primary lighten-2" @click="editing = true" >edit</v-icon>
                    </v-btn>
                    <span>Editar observación</span>
                    <RequerimientoObservacionEdit
                            :allowed="allowed"
                            :observacion="currentObservacion"
                            @hideDialog="hideEdit"
                            @updateObservacion="updateObservacion"
                            v-if="editing">
                    </RequerimientoObservacionEdit>
                </v-tooltip>
                <div>{{ currentObservacion.author.username }} - {{ currentObservacion.modified }}</div>
                <div>{{ currentObservacion.author.firstName }} {{ currentObservacion.author.lastName }} - {{ currentObservacion.departamentoNombre }}</div>
            </div>

<!--            MESSAGE-->
            <v-card :class="[isSafObservation(currentObservacion.author) ? 'xs8 primary lighten-1 flex ':' xs8 flex white']" >
                <v-card-text class="text-formatted">{{ currentObservacion.observacion }}
                </v-card-text>
            </v-card>

<!--            CLUB-->
            <div v-if="!isSafObservation(currentObservacion.author)" style="margin-left:15px" class="grey--text xs4 flex">
                <v-tooltip bottom class="action-buttons" v-if="allowed === 'user'  && currentObservacion.canEdit">
                    <v-btn small icon flat color="#293968" slot="activator" v-if="editable">
                        <v-icon color="primary lighten-2" @click="editing = true" >edit</v-icon>
                    </v-btn>
                    <span>Editar observación</span>
                    <RequerimientoObservacionEdit
                            :allowed="allowed"
                            :observacion="currentObservacion"
                            @hideDialog="hideEdit"
                            @updateObservacion="updateObservacion"
                            v-if="editing">
                    </RequerimientoObservacionEdit>
                </v-tooltip>
                <div>{{ currentObservacion.author.username }} - {{ currentObservacion.modified }}</div>
                <div>{{ currentObservacion.author.firstName }} {{ currentObservacion.author.lastName }}</div>
            </div>

        </v-flex>
    </v-layout>
</template>

<script>
import RequerimientoObservacionEdit from './RequerimientoObservacionEdit'

export default {
  components: {
    RequerimientoObservacionEdit
  },
  props: {
    requerimiento: Object,
    observacion: Object,
    allowed: String,
    editable: Boolean
  },

  data () {
    return {
      editing: false,
      currentObservacion: this.observacion
    }
  },

  methods: {
    isSafObservation (observacion) {
      return observacion.club === 'None'
    },
    hideEdit () {
      this.editing = false
    },
    updateObservacion (observacion) {
      this.currentObservacion = observacion
      this.$emit('updateObservacion', observacion)
      this.hideEdit()
    }
  }
}
</script>

<style scoped>
    .observation-text {
        font-size: 1.1em;
        margin-bottom: 25px;
        font-family: SourceSansProRegular, sans-serif;
        color: #575353;
    }
    .observation {
        white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
        white-space: -pre-wrap; /* Opera */
        white-space: -o-pre-wrap; /* Opera */
        white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
        word-wrap: break-word; /* IE 5.5+ */
        width: 100%;
        margin-top: 5px;
    }
</style>
